import { action, makeObservable, observable, runInAction } from 'mobx'
import { BaseProductModel } from '@/components/ProductList/BaseProductList'
import { MerchantProductModel } from '@/components/ProductList/CheckboxProduct'
import { request } from '@/framework/network/request'
import { message, notification } from 'antd'
import customHistory from "@/framework/customHistory";

export default class ShoppingCartStore {
  loading: boolean
  selectedValues: Map<string | number, BaseProductModel[]> // 选中的商品
  selectedCount: number //商品选中数量
  selectedTotalPrice: number  //商品选中总价
  cartList: Array<MerchantProductModel> // 购物车列表
  orderId: String //订单id
  payId: String //支付id
  amount: number  //支付金额

  constructor () {
    makeObservable(this, {
      loading: observable,
      selectedValues: observable,
      cartList: observable,
      selectedCount: observable,
      selectedTotalPrice: observable,
      orderId: observable,
      payId: observable,
      amount: observable,

      getCartList: action,
      setSelectedValues: action,
      shoppingCartAdd: action,
      deleteShoppingCart: action,
      createOrderByCarts: action,
    })
    this.loading = false
    this.selectedValues = new Map<string | number, any>()
    this.cartList = []
    this.selectedCount = 0
    this.selectedTotalPrice = 0
    this.orderId = ""
    this.payId = ""
    this.amount = 0
  }

  // 获取购物车列表
  getCartList = async () => {
    runInAction(() => {
      this.loading = true
    })
    try {
      const res = await request.get(`/carts`)
      // console.log('info---------------', res)
      if (res && res.status === 1 && res.data.length !== 0) {
        runInAction(() => {
          // const tempList = res.data[0].carts?.map(
          //   (item: any) => {
          //     return {
          //       title: item.productName,
          //       property: item.skuAttr1ValueName + '/' + item.skuAttr2ValueName,
          //       key: item.id,
          //       price: item.price,
          //       quantity: item.number,
          //     }
          //   }
          // )
          // this.cartList = [
          //   {
          //     id: Math.random() * 100 + 12,
          //     name: '商铺名称',
          //     productList: tempList
          //   }
          // ]
          this.cartList = res.data.map((item: any) => {
              return {
                id: item.merchantId,
                name: item.merchantName,
                productList: item.carts.map((it: any) => {
                  return {
                    title: it.productName,
                    property: it.skuAttr1ValueName + '/' + it.skuAttr2ValueName,
                    key: it.id,
                    id: it.id,
                    price: it.price,
                    merchantName: item.merchantName,
                    quantity: it.number,
                    titleFile: it.picture,
                  }
                })
              }
            }
          )
        })
      } else {
        this.cartList = []
        // message.info('您的购物车空空如也')
      }
    } catch (e) {
      notification.open({
        message: '提示框',
        description: '网络错误，请重试',
        onClick: () => {
          // console.log('1111')
        },
      })
    }

    runInAction(() => {
      this.loading = false
    })
  }

  // 选中的店铺产品
  setSelectedValues = (selectedRows: BaseProductModel[], merchantId: string | number) => {
    if (selectedRows.length) {
      this.selectedValues.set(merchantId, selectedRows)
    } else {
      this.selectedValues.delete(merchantId)
    }
    // 获取选中商品数量及总价价格
    let count = 0
    let totalPrice = 0
    this.selectedValues.forEach((value: BaseProductModel[], key: string | number) => {
      count += value.length
      value.forEach((it: BaseProductModel) => {
        totalPrice += it.quantity! * (it.price || 0)
      })
    })
    runInAction(() => {
      this.selectedCount = count
      this.selectedTotalPrice = totalPrice
    })
  }

  shoppingCartAdd = async (id: string, index: number, isAdd: boolean, price: number) => {
    runInAction(() => {
      this.loading = true
    })
    if (isAdd) {
      index = index + 1
      if (this.selectedValues && this.selectedValues.size !== 0 && price && price !== 0) {
        runInAction(() => {
          this.selectedTotalPrice = this.selectedTotalPrice + price
          this.selectedCount = this.selectedCount + 1
        })
      }
    } else {
      index = index - 1
      if (this.selectedValues && this.selectedValues.size !== 0 && price && price !== 0) {
        runInAction(() => {
          this.selectedTotalPrice = this.selectedTotalPrice - price
          this.selectedCount = this.selectedCount - 1
        })
      }
    }
    const res = await request.put(`/cart/${id}/number/${index}`, {})

    if (res && res.status === 1) {
        if (isAdd) {
            message.success('新增成功')
        } else {
            message.success('删减成功')
        }
    } else {
      message.error('网络错误')
    }
    this.getCartList()
    runInAction(() => {
      this.loading = false
    })
  }

  /**
   * 移除购物车
   * @param id
   * @param price
   */
  deleteShoppingCart = async (id: string, price: number) => {
    // console.log("删除商品 从购物车中——————————————————",id)
    runInAction(() => {
      this.loading = true
    })
    const res = await request.delete(`/cart/${id}`)
    if (this.selectedValues && this.selectedValues.size !== 0 && price && price !== 0) {
      runInAction(() => {
        this.selectedTotalPrice = this.selectedTotalPrice - price
        this.selectedCount = this.selectedCount - 1
      })
    }
    if (res && res.status === 1) {
      console.log('移除商品成功')
    } else {
      message.warn('网络错误！')
    }
    runInAction(() => {
      this.getCartList()
      this.loading = false
    })
  }

  /**
   * 通过 购物车生成订单
   */
  createOrderByCarts = async () => {
    //Todo:需要修改购物车数量接口
    //todo: 订单接口需要移除已经生成订单的id
    //todo: 跳转订单页面
    runInAction(() => {
      this.loading = true
    })

    let list: any[] = []
    this.selectedValues.forEach((value, key, map) => {
      if (value && value.length > 0) {
        const listTemp = value.map(it => it.id)
        list = list.concat(listTemp)
        // list.push(value.map(it=>it.id))
      }
      // console.log('key-------------', key)
      // console.log('map------------', map)
    })
    // console.log("listInfo --------",list)
    // console.log("this.list---------------",this.selectedValues.keys())
    // console.log("this.list---------------",this.selectedValues)
    if (this.selectedValues && this.selectedValues.size !== 0 && list.length > 0) {
      const res = await request.post(`/order:create`, list)
      this.orderId = res.data[0].id
      this.payId = res.data[0].payId
      this.amount = res.data[0].payment
      if (res && res.status === 1) {
        console.log('生成订单成功！')
        // console.log(res.data)
        this.selectedValues.forEach((value: BaseProductModel[], key: string | number) => {
          value.forEach((it: BaseProductModel) => {
            // console.log(it)
            if (it.id != null && it.price != null) {
              this.deleteShoppingCart(it.id, it.price)
            }
          })
        })
        customHistory.push(`/pay`)
      } else {
        message.error('网络错误！')
      }
    }
    this.getCartList()
    runInAction(() => {
      this.loading = false
    })
  }
}
